export default __webpack_public_path__ + "static/media/baller-logo-3.5007e69b.png";